/**
 * @file DealsBoardColumn.tsx
 * @description Колонка стадии на доске сделок (phase09; phase19.31 —
 * вынесено из страницы): шапка «● Название · N», карточки, приём
 * перетаскивания. Цвет стадии магазина — только точкой в шапке (SC28).
 */

import { useDroppable } from "@dnd-kit/core";

import { KanbanCard } from "../KanbanCard";
import { StageDot } from "../StageDot";
import type { DealDto, PipelineStageDto } from "../../../lib/api-crm";
import { cn } from "@/lib/utils";

interface Props {
  stage: PipelineStageDto;
  deals: DealDto[];
  onCardClick: (deal: DealDto) => void;
}

export function DealsBoardColumn({ stage, deals, onCardClick }: Props) {
  const { setNodeRef, isOver } = useDroppable({
    id: `stage-${stage.id}`,
    data: { type: "stage", stageId: stage.id },
  });

  return (
    <div
      ref={setNodeRef}
      className={cn(
        "flex min-w-[260px] flex-1 flex-col gap-2 rounded-2xl bg-surface/40 p-3 transition-colors",
        isOver && "bg-primary/5 [box-shadow:inset_0_0_0_2px_var(--primary)]",
      )}
    >
      <div className="flex items-center gap-2 px-1">
        <StageDot color={stage.color} />
        <span className="type-body flex-1 truncate font-medium">{stage.name}</span>
        <span className="type-caption tabular-nums text-on-surface-variant">{deals.length}</span>
      </div>
      <div className="flex min-h-12 flex-col gap-2">
        {deals.map((deal) => (
          <KanbanCard key={deal.id} deal={deal} onClick={() => onCardClick(deal)} />
        ))}
        {deals.length === 0 && !isOver ? (
          <div className="type-caption py-4 text-center text-on-surface-variant">Перетащите сюда</div>
        ) : null}
      </div>
    </div>
  );
}
